import React, { useEffect, useState } from "react";
import {
  useCreateServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useProductTypeQuery,
  useServicesQuery,
  useSingleProductTypeQuery,
  useStatusChangeServiceTypeMutation,
  useChangeServiceTypeMutation,
  useUpdateServiceTypeMutation,
} from "../../../Store/Apis/servicesApi";
import Error from "../../../Components/Error/Error";
import Loader from "../../../Components/Loader/Loader";
import { Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import AddEditServiceSpec from "../../../Components/AddEditServiceSpec/AddEditServiceSpec";
import { useSelector } from "react-redux";
import { isDropdownPermission } from "../../../Hooks/permissionsMiddleware";
import { useOutletsQuery } from "../../../Store/Apis/outletApi";

const ProductType = () => {
  const user = useSelector((state) => state.auth.user);

  const [sortFilter, setSortFilter] = useState({
    search: "",
    filter: "",
    outletID: "",
  });
  const productTypeApi = useProductTypeQuery({
    keyword: sortFilter.search,
    keyID: sortFilter.filter,
    outletID: sortFilter.outletID,
  });
  // const serviceList = useServicesQuery()
  const outletList = useOutletsQuery();

  // ADD SERVICE TYPE SPEC
  const [addServiceModalShow, setAddServiceModalShow] = useState(false);
  const AddService = () => {
    const [createServiceType, createServiceTypeResponse] =
      useCreateServiceTypeMutation();
    const handleCreateServiceSubmit = (formData) => {
      console.log(formData);
      const createServiceTypeBody = {
        outletID: formData.category,
        serviceTypeName: formData.serviceName,
        isActive: 1,
      };
      createServiceType(createServiceTypeBody)
        .then((res) => {
          console.log(res);
          if (res?.data?.status == 200) {
            toast.success(res?.data?.message, { duration: 7000 });
            setAddServiceModalShow(false);
          } else {
            toast.error(res?.data?.message, { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error(err, { duration: 7000 });
        });
    };

    return (
      <Modal
        show={addServiceModalShow}
        onHide={() => setAddServiceModalShow(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Service Specification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditServiceSpec onSubmit={handleCreateServiceSubmit} />
        </Modal.Body>
      </Modal>
    );
  };

  // EDIT SERVICE PRODUCT
  const [updateServiceType, updateServiceTypeResponse] =
    useUpdateServiceTypeMutation();
  const [updateProductTypeId, setUpdateProductTypeId] = useState(null);
  const [updateProductTypeIdModalShow, setProductTypeIdModalShow] =
    useState(false);
  const singleProductType = useSingleProductTypeQuery(
    {
      prodID: updateProductTypeId,
    },
    { skip: !updateProductTypeId }
  );

  const UpdateProductType = () => {
    const handleUpdate = (formData) => {
      console.log("Update Service Category Submitted:", formData);
      const updateBody = {
        id: updateProductTypeId,
        serviceTypeName: formData.serviceName,
        categoryId: formData.category,
        isActive: 1,
      };

      updateServiceType(updateBody)
        .then((res) => {
          if (res?.data?.status === 200) {
            setProductTypeIdModalShow(false);
            toast.success(res?.data?.message, { duration: 7000 });
          } else {
            toast.error(res?.error?.data?.message, { duration: 7000 });
          }
        })
        .catch((err) => {
          toast.error("An error occurred. Please try again.", {
            duration: 7000,
          });
        });
    };

    return (
      <Modal
        show={updateProductTypeIdModalShow}
        onHide={() => setProductTypeIdModalShow(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Service Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditServiceSpec
            onSubmit={handleUpdate}
            data={{
              serviceName: singleProductType?.data?.data[0]?.serviceTypeName,
            }}
          />
        </Modal.Body>
      </Modal>
    );
  };

  // STATUS CHANGE
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [changeStatus] = useChangeServiceTypeMutation();
  const handleChangeStatus = () => {
    changeStatus(selectedStatus)
      .then((res) => {
        console.log(res);
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message, { duration: 7000 });
        } else {
          // Handle API error response (like 409) - follow same pattern as handleUpdate
          toast.error(res?.error?.data?.message, { duration: 7000 });
        }
        setSelectedStatus(null);
      })
      .catch((err) => {
        // Handle network or other errors
        console.error("Error updating status:", err);
        toast.error("An error occurred. Please try again.", { duration: 7000 });
        setSelectedStatus(null);
      });
  };

  // DELETE
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [deleteProductType] = useDeleteServiceTypeMutation();
  const handleDelete = () => {
    deleteProductType(selectedRecord).then((res) => {
      console.log(res);
      setSelectedRecord(null);
    });
  };

  useEffect(() => {
    if (user.role !== "superAdmin") {
      setSortFilter({
        ...sortFilter,
        outletID: user.outletID,
      });
    }
  }, []);

  const columns = [
    {
      title: "Service Type",
      dataIndex: "serviceTypeName",
      key: "serviceTypeName",
      sorter: (a, b) => a.serviceTypeName.localeCompare(b.serviceTypeName),
      filter: (value, record) =>
        record.serviceTypeName.toLowerCase().includes(value.toLowerCase()),
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) =>
        record.serviceTypeName.toLowerCase().includes(value.toLowerCase()),
      render: (i, action) => (
        <>
          <p className="mb-1 text-sm">{action.serviceTypeName}</p>
        </>
      ),
    },
    // {
    //   title: 'Category',
    //   dataIndex: 'serviceCategoryName',
    //   key: 'serviceCategoryName',
    //   render: (i, action) => (
    //     <>
    //       <p className='mb-1 text-sm'>{action.serviceCategoryName}</p>
    //     </>
    //   )
    // },
    // {
    //   title: 'Outlet',
    //   dataIndex: 'outlet',
    //   key: 'outletName',
    //   render: (i, action) => (
    //     <>
    //       <p className='mb-1 text-sm'>{action.outletName}</p>
    //     </>
    //   )
    // },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (i, action) => (
        <button
          type="button"
          className={`btn badge badge-xs ${
            action.isActive == 1 ? "badge-success" : "badge-danger"
          } fw-600 text-xs mb-0`}
          onClick={() =>
            setSelectedStatus({
              id: action.id,
              isActive: action.isActive == 1 ? 0 : 1,
              serviceTypeName: action.serviceTypeName,
              categoryId: action.categoryId,
            })
          }
        >
          {action.isActive == 1 ? "Active" : "Deactivated"}
        </button>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (i, action) => (
        <>
          <button
            type="button"
            className="btn ms-2 badge badge-xs badge-warning text-xs fw-600 mb-0"
            onClick={() => (
              setUpdateProductTypeId(action.id), setProductTypeIdModalShow(true)
            )}
          >
            View & Edit
          </button>
          <button
            type="button"
            className="btn ms-2 badge badge-xs badge-danger text-xs fw-600 mb-0"
            onClick={() => setSelectedRecord(action.id)}
            disabled={action.quantity > 0}
            style={{
              opacity: action.quantity > 0 ? "0.6" : "1",
            }}
          >
            Delete
          </button>
          {action.quantity > 0 && (
            <span
              title="Cannot delete item with a quantity linked to it"
              className="cursor-pointer ms-2 badge badge-sm bg-dark rounded-pill"
            >
              <i className="fa fa-info"></i>
            </span>
          )}
        </>
      ),
    },
  ];

  return (
    <div>
      <div className="row align-items-center justify-content-between mb-3">
        <div className="col">
          <h5 className="fw-500 text-white">Service/Product Type</h5>
        </div>
        {/* <div className="col-auto">
          <Link onClick={() => setAddServiceModalShow(true)} className="btn btn-icon btn-3 btn-white text-primary mb-0 mx-1">
            <i className="fa fa-plus me-2"></i> Add Service/Product Type
          </Link>
        </div> */}
      </div>
      <div className="card mb-4">
        <div className="card-header p-4">
          <div className="row gx-3">
            <div className="col-md-9">
              <input
                type="text"
                className="form-control"
                placeholder="Search by Service/Product Type"
                value={sortFilter?.search || ""}
                onChange={(e) =>
                  setSortFilter({ ...sortFilter, search: e.target.value })
                }
              />
            </div>
            <div className="col-md-3">
              <select
                className="form-select"
                onChange={(e) =>
                  setSortFilter({ ...sortFilter, filter: e.target.value })
                }
                value={sortFilter?.outletID}
                disabled={
                  outletList.isSuccess === true &&
                  !isDropdownPermission(user.role_Id)
                }
              >
                <option value="">All Category</option>
                {outletList?.data?.data.map((elem, i) => (
                  <option value={elem.outletId} key={i}>
                    {elem.outletName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          {productTypeApi.isError && <Error />}
          {productTypeApi.isLoading && <Loader height="500px" />}
          {productTypeApi.isSuccess && (
            <Table columns={columns} dataSource={productTypeApi?.data?.data} />
          )}
          <AddService />
          <UpdateProductType />
        </div>
      </div>

      {/* STATUS CHANGE MODAL */}
      <Modal
        show={selectedStatus}
        onHide={() => setSelectedStatus(null)}
        size="sm"
        centered
      >
        <Modal.Body className="text-center p-4">
          <h5 className="mb-4">Are you sure you want to change status?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button
              className="btn btn-danger bg-danger btn-sm mb-0"
              onClick={() => setSelectedStatus(null)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm mb-0"
              onClick={handleChangeStatus}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* DELETE MODAL */}
      <Modal
        show={selectedRecord}
        onHide={() => setSelectedRecord(null)}
        size="sm"
        centered
      >
        <Modal.Body className="text-center p-4">
          <h5 className="mb-4">Are you sure you want to delete the brand?</h5>
          <div className="buttons d-flex gap-3 justify-content-center">
            <button
              className="btn btn-danger bg-danger btn-sm mb-0"
              onClick={() => setSelectedRecord(null)}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary btn-sm mb-0"
              onClick={handleDelete}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductType;
